// Single source of truth for the Dessert Of The Week feature.
// Update this each Monday for the new week.
//
// Fields:
//   active        — set to false to hide the entire section
//   name          — short product name shown as the headline
//   description   — 1-2 sentences (plain text, emojis OK)
//   image         — full public URL (use customer-assets.emergentagent.com uploads or any CDN).
//                   Leave empty ("") to show the "Photo coming soon" placeholder.
//   imageContain  — true to show the WHOLE image (letterboxed) instead of cropping to fill.
//                   Use for promo graphics with text; leave false/absent for photos.
//   priceLabel    — optional, e.g. "$12.50" or "From $8.50". Omit (empty string) to hide.
//   priceNote     — optional small qualifier shown next to the price (e.g. "In store price").
//   inStoreOnly   — true to hide the "On delivery platforms" chip (in-store exclusive deals).
//   weekStarting  — optional ISO date "YYYY-MM-DD" of the first day featured.
//                   If only this is set, the range shown is start + 6 days (Mon–Sun).
//   weekEnding    — optional ISO date "YYYY-MM-DD" of the last day featured.
//                   Set BOTH start and end together to show an exact range
//                   (e.g. start=Tue 16 Jun, end=Sun 21 Jun).
//                   Leave both empty to auto-detect the current calendar week.

export const DESSERT_OF_THE_WEEK = {
  active: true,
  name: "Roll Your Own Ice Cream Sessions",
  description:
    "Want to experience getting behind the cold plate yourself? Come and experience a Roll Your Own Session these school holidays! Available 12pm – 5pm daily. At times there may be a small wait.",
  image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_rolled-bliss/artifacts/45h42z6h_image.png",
  imageContain: true,
  priceLabel: "$12.00",
  priceNote: "In store price",
  inStoreOnly: true,
  weekStarting: "2026-09-07",
  weekEnding: "2026-09-20",
};
